"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Simple type guard to cast PayloadAction -> Success/Failure actions
 */
exports.isSuccessfulAction = function (action) { return action.error !== true; };
/**
 * Casts the action to success but will throw if the action was not actually a successful one.
 */
function assumeSuccessfulAction(action) {
    if (exports.isSuccessfulAction(action)) {
        return action;
    }
    throw new Error("assumed '" + action.type + "' action was successful when it was not");
}
exports.assumeSuccessfulAction = assumeSuccessfulAction;
exports.createSuccessAction = function (type, payload) { return ({
    type: type,
    payload: payload,
    error: false,
}); };
exports.createFailedAction = function (type, error) { return ({
    type: type,
    payload: error,
    error: true,
}); };
